module.exports = __webpack_public_path__ + "static/media/create_sections_edit_main_section.33fd56ff.mov";